import { http } from "@/lib/api";

export function saveBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export async function downloadFrom(path, filename) {
  const r = await http.get(path, { responseType: "blob" });
  saveBlob(r.data, filename);
}

export const safeName = (s, fallback = "artifact") => (s || fallback).replace(/[\\/:*?"<>|]+/g, " ").trim().slice(0, 80) || fallback;
